module.exports = __webpack_public_path__ + "img/Lato-Italic.6b7ff16d.svg";